import HowBelieveWorksScreen from 'features/believe/learningCenter/HowBelieveWorksScreen/HowBelieveWorksScreen';
import React from 'react';

export default function Page() {
  return <HowBelieveWorksScreen />;
}
